module.exports = __webpack_public_path__ + "0af38835e21c015e8bd6e9b1110c1447.svg";